module.exports = __webpack_public_path__ + "static/media/undraw_newspaper.1efe32df.svg";